var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState, useEffect } from 'react';
import { ButtonGroup, Modal, ModalOverlay, ModalContent, ModalHeader, ModalFooter, ModalBody, Text, Button, Input, Stack, Box, useDisclosure, } from '@noom/wax-component-library';
import { usePlateEditorState, ToolbarButton } from '@udecode/plate';
import { removeLink, insertLink, getSelectedText, isLinkActive } from '../utils';
const LinkModal = (_a) => {
    var { isOpen, onClose, onSubmit, titleText = 'Add link', colorScheme = 'primary', defaultUrl = 'https://', defaultText = '' } = _a, modalProps = __rest(_a, ["isOpen", "onClose", "onSubmit", "titleText", "colorScheme", "defaultUrl", "defaultText"]);
    const [url, setUrl] = useState(defaultUrl);
    const [text, setText] = useState(defaultText);
    useEffect(() => {
        // Reset form on show
        if (isOpen) {
            setUrl(defaultUrl);
            setText(defaultText);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isOpen]);
    useEffect(() => {
        if (url.includes('https://https://') || url.includes('https://http://')) {
            setUrl(url.replace('https://', ''));
        }
    }, [url]);
    function submit(event) {
        if (event) {
            event.preventDefault();
        }
        onSubmit(url === null || url === void 0 ? void 0 : url.trim(), text === null || text === void 0 ? void 0 : text.trim());
        onClose();
    }
    return (React.createElement(Modal, Object.assign({ isOpen: isOpen, onClose: onClose }, modalProps),
        React.createElement(ModalOverlay, null),
        React.createElement(ModalContent, null,
            React.createElement(ModalHeader, null,
                React.createElement(Text, { colorScheme: colorScheme }, titleText)),
            React.createElement(ModalBody, null,
                React.createElement("form", { onSubmit: (event) => submit(event) },
                    React.createElement(Stack, { spacing: 2 },
                        React.createElement(Box, null,
                            React.createElement(Input, { label: "URL", name: "url", value: url, size: "md", boxSizing: "border-box", onChange: (event) => setUrl(event.currentTarget.value) })),
                        React.createElement(Box, null,
                            React.createElement(Input, { label: "Text", name: "text", value: text, size: "md", boxSizing: "border-box", isDisabled: !!defaultText, onChange: (event) => setText(event.currentTarget.value) }))),
                    React.createElement(Button, { type: "submit", display: "none" }))),
            React.createElement(ModalFooter, null,
                React.createElement(ButtonGroup, { spacing: 2 },
                    React.createElement(Button, { variant: "outline", size: "md", colorScheme: colorScheme, onMouseDown: onClose }, "Cancel"),
                    React.createElement(Button, { border: "none", variant: "solid", size: "md", colorScheme: colorScheme, isDisabled: !url.length, onMouseDown: () => submit() }, "Add"))))));
};
export const LinkToolbarButton = (_a) => {
    var props = __rest(_a, []);
    const editor = usePlateEditorState();
    const { isOpen, onClose, onOpen } = useDisclosure();
    if (!editor) {
        return null;
    }
    const selectedText = getSelectedText(editor);
    function onMouseDown(event) {
        event.preventDefault();
        onOpen();
    }
    function insert(url, text) {
        if (url && editor) {
            insertLink(editor, url, text);
        }
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(ToolbarButton, Object.assign({ active: isLinkActive(editor), onMouseDown: (event) => __awaiter(void 0, void 0, void 0, function* () {
                onMouseDown(event);
            }) }, props)),
        React.createElement(LinkModal, { isOpen: isOpen, size: "md", defaultText: selectedText, onClose: onClose, onSubmit: (url, text) => insert(url, text) })));
};
export const UnLinkToolbarButton = (_a) => {
    var props = __rest(_a, []);
    const editor = usePlateEditorState();
    if (!editor) {
        return null;
    }
    return (React.createElement(ToolbarButton, Object.assign({ onMouseDown: () => {
            removeLink(editor);
        } }, props)));
};
//# sourceMappingURL=LinkButton.js.map